<template>
    <div>
        <v-form ref="form" class="p-2">
           <v-row dense>
                <v-col cols="12" md="3">
                    <v-select
                        v-model="item.description"
                        :items="descriptionItems"
                        :rules="[rules.required]"
                        outlined
                        dense
                        :class="$css_field"
                        label="Descrição"
                    />
                </v-col>
                <v-col cols="12" md="3">
                    <v-text-field
                        v-model="item.complement"
                        outlined
                        dense
                        :class="$css_field"
                        label="Complemento (Opcional)"
                    />
                </v-col>
                <v-col cols="12" md="2">
                    <v-menu
                        v-model="calendar.expiration_date"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                dense
                                outlined
                                v-model="item.expiration_date"
                                append-icon="mdi-calendar-range"
                                readonly
                                v-on="on"
                                :class="$css_field"
                                @click="expiration_date = null"
                                :rules="[rules.required]"
                            >
                                <template v-slot:label>
                                    <span :class="$css_field">Data Vencimento</span>
                                </template>
                            </v-text-field>
                        </template>

                        <v-date-picker locale="pt-br" v-model="expiration_date" @input="calendar.expiration_date = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" md="2">
                    <v-menu
                        v-model="calendar.notice_date"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                dense
                                outlined
                                v-model="item.notice_date"
                                append-icon="mdi-calendar-range"
                                readonly
                                v-on="on"
                                :class="$css_field"
                                @click="notice_date = null"
                                :rules="[rules.required]"
                            >
                                <template v-slot:label>
                                    <span :class="$css_field">Data Alerta</span>
                                </template>
                            </v-text-field>
                        </template>

                        <v-date-picker locale="pt-br" v-model="notice_date" @input="calendar.notice_date = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" md="2">
                    <v-btn
                        color="primary"
                        @click="validate"
                        :class="$css_button"
                    >
                        <span>Adicionar</span>
                    </v-btn>
                </v-col>  
            </v-row>
        </v-form> 
        <v-row v-if="items" class="mt-3">
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">  
                <v-card
                    class="mx-auto"
                    outlined
                >
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        :items-per-page="10"
                        class="elevation-1 table-striped"
                        :footer-props="{
                        'items-per-page-text':'Itens por página',
                        'items-per-page-options': [5, 10],
                        'items-per-page-all-text': '',
                        'page-text': '{0}-{1} de {2}'
                    }"
                    >
                        <template v-slot:[`item.description`]="{ item }">
                            {{ item.description }}
                            <span v-if="item.complement">
                                ({{ item.complement }})
                            </span>
                        </template>

                        <template v-slot:[`item.expiration_date`]="{ item }">
                            {{ formatDate(item.expiration_date) }}
                        </template>

                        <template v-slot:[`item.notice_date`]="{ item }">
                            {{ formatDate(item.notice_date) }}
                        </template>

                        <template v-slot:[`item.actions`]="{ item }">
                            <v-card-actions>
                                <v-tooltip left>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon @click.prevent="destroy(item)" class="ml-8">
                                            <v-icon v-bind="attrs" v-on="on">mdi-delete</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Excluir</span>
                                </v-tooltip>
                            </v-card-actions>     
                        </template>
                        
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>  
    </div>
</template>

<script>
    export default {
       
        props: {
            object: {
                require: true,
            },
        },

        watch: {
            object: {
                handler() {
                    this.setObject();           // ← configura o formulário com os dados
                },
                immediate: true // ← garante que execute mesmo se já estiver definido
            },

            expiration_date () {
                this.item.expiration_date = this.formatDate(this.expiration_date);
            },

            notice_date () {
                this.item.notice_date = this.formatDate(this.notice_date);
            },
        }, 

        data () {
            return {
                items: [],

                item: {},

                descriptionItems: ['Seguro Incêndio','Outros'],

                rules: {
                    required: value => !!value || 'Obrigatório.',
                    email: value => /.+@.+/.test(value) || 'E-mail precisa ser válido'
                },

                headers: [
                    { text: 'DESCRIPTION', align: 'start', value: 'description', sortable: false },
                    { text: 'DT EXPIRAÇÃO',  value: 'expiration_date', sortable: false },
                    { text: 'DT ALERTA', value: 'notice_date', sortable: false },  
                    { text: 'AÇÕES', value: 'actions', sortable: false },                
                ],

                expiration_date: '',
                notice_date: '',
                calendar: {
                    expiration_date: '',
                    notice_date: ''
                }
            }
        },

        methods:{   
            setObject(){
                this.items = this.object.items 
            },

            validate () {
                if (this.$refs.form.validate()) {       
                    this.storeUpdate()
                }
            },
            
            storeUpdate(){
                const item = {}
                if(this.item.id && this.item.id != ''){
                    item.id = this.item.id        
                }else{
                    item.model = this.object.model
                    item.item_id = this.object.item_id    
                }

                item.description = this.item.description;
                item.complement = this.item.complement;
                item.expiration_date = this.expiration_date;
                item.notice_date = this.notice_date;
            
                const action = item.id ? 'updateAlert' : 'storeAlert'
                this.$store.dispatch(action, item)
                            .then(response => {
                                const reponse = response.data
                                // Verifica se já existe um colaborador com o mesmo id no array
                                const index = this.items.findIndex(c => c.id === reponse.id);

                                if (index > -1) {
                                    // Se existir, substitui
                                    this.$set(this.items, index, reponse);
                                } else {
                                    // Se não existir, adiciona
                                    this.items.push(reponse);
                                }

                                this.items.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

                                this.$snotify.success('Cadastro com sucesso!')
                                this.reset()
                            })
                            .catch(error => {   
                                this.$snotify.error('Erro no cadastro')
                                this.errors = error.response.data.errors
                            }) 
            },

            reset(){
                this.item = {}
                this.$refs.form.reset()
            },

            destroy(item){
                this.$store.dispatch('destroyAlert', item.id)
                            .then(response => {
                                // Encontra o índice do colaborador no array
                                const index = this.items.findIndex(c => c.id === item.id);

                                if (index > -1) {
                                    // Remove reativamente do array
                                    this.items.splice(index, 1);
                                }
                            })
                            .catch(error => {
                                this.$snotify.error('Erro no cadastro')
                                this.errors = error.response.data.errors
                            })
                            .finally(
                                //this.$snotify.remove()
                                this.$snotify.success('Registro excluído com sucesso!')
                            )
            },
            
        }    
    }
</script>